import { render, staticRenderFns } from "./ShipDoc.vue?vue&type=template&id=552f33a3&"
import script from "./ShipDoc.vue?vue&type=script&lang=js&"
export * from "./ShipDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports